import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Text } from 'foundations-components/components/Text';
import { Small } from 'foundations-components/transitional/components/Small';
import getTooltipPropsByStatusAndMetadata from './getTooltipContentByStatusAndMetadata';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SmartPropertyRunStatusTooltip = ({
  status,
  metadata,
  children
}) => {
  const {
    headingIcon,
    headingText,
    bodyHeader,
    body
  } = getTooltipPropsByStatusAndMetadata(status, metadata);
  return /*#__PURE__*/_jsx(Tooltip, {
    headingText: /*#__PURE__*/_jsxs(Text, {
      typography: "heading-100",
      children: [headingIcon, headingText]
    }),
    inlineSize: "300px",
    padding: "500",
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-25",
        children: bodyHeader
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(Small, {
          children: body
        })
      })]
    }),
    use: "longform",
    children: children
  });
};